import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "pqq0uvmj", 
  dataset: "production", 
});